import { EaStatus } from './ea-status-bar.models';

export const eaStatusIconsByStatusType: Record<EaStatus, string> = {
    [EaStatus.ERROR]: 'block',
    [EaStatus.WARNING]: 'warning',
    [EaStatus.SUCCESS]: 'check_circle'
};

export const DEFAULT_STATUS_BAR_DELAY_MS = 3000;
